<script lang="ts">
    import dayjs from "dayjs";
    import relativeTime from "dayjs/plugin/relativeTime";
    import {availableAddresses} from "$lib/calls/address";
    import AddressDisplay from "$lib/components/AddressDisplay.svelte";
    import AssociateDisplay from "$lib/components/AssociateDisplay.svelte";
    import fromEntityStore from "$lib/utils/fromEntityStore.js";
    import ProjectDocuments from "$lib/components/ProjectDocuments.svelte";
    import Avatar from "$lib/components/Avatar.svelte";
    import {availableAssociates, currentCustomer} from "$lib/stores/customer";
    import {Accordion, AccordionItem} from "flowbite-svelte";
    import {
        BuildingSolid,
        CalendarMonthSolid,
        ClipboardListOutline, ExclamationCircleSolid,
        GridSolid,
        InfoCircleSolid, MapPinAltSolid, PaperClipOutline, UsersGroupSolid, UserSolid,
        UsersSolid
    } from "flowbite-svelte-icons";
    import {onMount} from "svelte";
    import {Language, setLocale} from "$lib/utils/i18nDate";
    import WorkEntryDisplay from "$lib/partials/WorkEntryDisplay.svelte";
    import {availableQualifications} from "$lib/calls/qualification";
    import {fullCustomer} from "$lib/calls/customer";

    export let project;

    export let mode = 'create';

    let associates;
    availableAssociates.subscribe(x => associates = x);

    let customer;
    currentCustomer.subscribe(async x => {
        customer = x
        if(customer && !customer.address){
            customer = await fullCustomer(customer.uuid)
        }
    });

    let element;


    let possibleAddresses: Array<any> = [];

    let qualifications;

    $: displayTimeframe = () => {
        const start = project.startsAt.value || project.startsAt
        const end = project.endsAt.value || project.endsAt
        return dayjs(start).format('DD.MM.YYYY') + (start === end ? '' : ' - ' + dayjs(end).format('DD.MM.YYYY'))
    }
    $: displayRequiredPersonell = () => {
        let count = 0;
        for (let i = 0; i < project.workEntries.length; i++) {
            count += parseInt(project.workEntries[i].amount);
        }
        return count;
    }

    $: howFarAlong = () => {
        const start = dayjs(project.startsAt.value || project.startsAt);
        try{
            return dayjs().to(start)
        } catch (e) {
            return ''
        }
    }
    onMount(async () => {
        await setLocale(Language.de)
        dayjs.extend(relativeTime)
        if(!project.address){
            possibleAddresses = await availableAddresses()
        }
        qualifications = await availableQualifications()
    })
</script>
<Accordion multiple>
    <div class="p-5 border-l border-r border-t rounded-tl-lg rounded-tr-lg border-b border-gray-200 dark:border-gray-700">
        <h3 class="text-2xl leading-7 text-neutral-600 border-b pb-5">{mode === 'create' ? 'Ihre Anfrage' : 'Ihr Projekt'} im Überblick</h3>
        {#if customer && customer.address}
            <div class="flex gap-3 mb-7 mt-6 place-items-center">
                <BuildingSolid class="text-primary-400"/>
                {customer.name}

            </div>
            {#if project.name &&  project.name.length > 0}
            <div class="flex gap-3 mb-7 place-items-center">
                <GridSolid class="text-primary-400"></GridSolid>
                {project.name}
            </div>
            {/if}
            {#if fromEntityStore(project, 'department')}
            <div class="flex gap-3 mb-7 place-items-center">
                <ClipboardListOutline class="text-primary-400"></ClipboardListOutline>
                {fromEntityStore(project, 'department') || ''}
            </div>
            {/if}
            {#if project.name}
            <div class="flex gap-3 place-items-center">
                <CalendarMonthSolid class="text-primary-400"></CalendarMonthSolid>
                {displayTimeframe()}
            </div>
            {/if}
        {/if}

    </div>

    {#if project.responsibleUserId}
    <AccordionItem>

        <div class="flex gap-3" slot="header">
            {#if project.associates && project.associates.length > 0}
                <UsersSolid class="text-primary-400"></UsersSolid>
                <div class="-mt-1 flex gap-2">
                    <Avatar bgColor="bg-primary-400" size="sm"
                            associate={associates.find(x => x.userId === project.responsibleUserId)}/>
                    {#each project.associates as associate}
                        <Avatar bgColor="bg-primary-400" size="sm"
                                associate={associates.find(x => associate.associateId ? x.id === associate.associateId : x.userId === associate.userId)}/>
                    {/each}
                </div>

            {:else}
                <UserSolid class="text-primary-400"></UserSolid>
                {associates && associates.find(x => x.userId === project.responsibleUserId)?.name || 'Besteller auswählen'}
            {/if}

        </div>
        <div class="flex gap-3 place-items-center -ml-1">
            {#if associates && project.responsibleUserId}
                <Avatar bgColor="bg-blue-600" size="sm"
                        associate={associates.find(x => x.userId === project.responsibleUserId)}/>
                <AssociateDisplay associate={associates.find(x => x.userId === project.responsibleUserId)}/>
            {/if}
        </div>
        {#if project.associates && project.associates.length > 0 && associates}
            <div class="flex gap-3 pt-3 mt-3 border-t  place-items-center">
                <UsersSolid class="text-primary-400"></UsersSolid>
                Weitere Ansprechpartner
            </div>

            <div class="grid gap-3 mt-3 -ml-1 place-items-center">
                {#each project.associates as associate}
                    <div class="flex gap-2" >
                        <Avatar bgColor="bg-blue-600" size="sm"
                                associate={associates.find(x => associate.associateId ? x.id === associate.associateId : x.userId === associate.userId)}/>
                        <AssociateDisplay associate={associates.find(x => associate.associateId ? x.id === associate.associateId : x.userId === associate.userId)}/>
                    </div>

                {/each}
            </div>
        {/if}
    </AccordionItem>
    {/if}
    {#if project.address || (project.addressUuid && possibleAddresses.length > 0)}
    <AccordionItem>
        <div class="flex gap-3 place-items-center" slot="header">
            <MapPinAltSolid class="text-primary-400"></MapPinAltSolid>
            {project.address ? project.address.name : (project.addressUuid ? possibleAddresses.find(x => x.uuid === project.addressUuid).name : 'Adresse auswählen') }
        </div>

        <div class="flex gap-3 place-items-center">
            {#if project.addressUuid}
                <AddressDisplay address={possibleAddresses.find(x => x.uuid === project.addressUuid)}/>
            {:else if project.address}
                <AddressDisplay address={project.address}/>
            {:else}
                <span>noch unbekannt</span>
            {/if}
        </div>
    </AccordionItem>
    {/if}
    {#if project.workEntries}
        <AccordionItem>
            <div class="flex gap-3 place-items-center" slot="header">
                <UsersGroupSolid class="text-primary-400"></UsersGroupSolid>
                <span>Personal: {displayRequiredPersonell()} Einsatzkräfte</span>
            </div>
            {#each project.workEntries as workentry}
                <WorkEntryDisplay {workentry} {qualifications}/>

            {/each}
        </AccordionItem>
    {/if}

    {#if project.tags}
        <AccordionItem >
            <div class="flex gap-3 place-items-center" slot="header">
                <InfoCircleSolid class="text-primary-400"></InfoCircleSolid>
                <span>Eventinfo</span>
            </div>
            <div class="grid grid-cols-2 gap-3">
                <h3 class="flex gap-3 place-items-center">
<!--                    <Icon name="ordored-list-outline" class="text-primary-400"/>-->
                    <i class="la la-users text-primary-400 text-[30px]"></i>
                    Erwartete Gäste
                </h3>
                {fromEntityStore(project, 'guests')} {parseInt(fromEntityStore(project, 'guests')) === 1 ? 'Gast' : 'Gäste'}
                <h3 class="flex gap-3 place-items-center">
                    <i class="la la-utensils text-primary-400 text-[30px]"></i>
<!--                    <Icon name="archive-solid" class="text-primary-400"/>-->
                    Kategorie
                </h3>
                {project.tags[project.tags.findIndex(x => x.identifier === 'category')]?.name || 'unbekannt'}
                <h3 class="flex gap-3 place-items-center">
                    <i class="la la-bullhorn text-primary-400 text-[30px]"></i>
<!--                    <Icon name="bullhorn-solid" class="text-primary-400"/>-->
                    Anlaß
                </h3>
                {project.tags[project.tags.findIndex(x => x.identifier === 'occasion')]?.name || 'unbekannt'}
                <h3 class="flex gap-3 place-items-center">
                    <i class="la la-user-tie text-primary-400 text-[30px]"></i>
<!--                    <Icon name="users-group-outline" class="text-primary-400"></Icon>-->
                    Dresscode
                </h3>
                {project.tags[project.tags.findIndex(x => x.identifier === 'outfit')]?.name || 'unbekannt'}
            </div>

        </AccordionItem>
    {/if}

    {#if project.notes}
        <AccordionItem>
            <div class="flex gap-3 place-items-center" slot="header">
                <ExclamationCircleSolid class="text-red-400"/>
                <span>Hinweis</span>
            </div>
            <p>{@html project.notes}</p>
        </AccordionItem>
    {/if}
    {#if project.documents}
        <AccordionItem>
            <div class="flex gap-3 place-items-center" slot="header">
                <PaperClipOutline class="text-primary-400"/>
                <span>Dokumente</span>
            </div>
            <ProjectDocuments {project}/>
        </AccordionItem>
    {/if}
</Accordion>

